<template>
    <div>
        <div class="modal fade inactivity" tabindex="-1" :id="modalId" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content text-center">
                    <div class="modal-body p-4">
                        <p :id="modalId + '-content'"></p>
                        <ColoredButton class="w-auto btn--yes" @click="hide">{{btnText}}</ColoredButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ColoredButton from './ColoredButton';
    export default {
        components: {
            ColoredButton
        },
        props: {
            modalId: {
                type: String,
                default: "alertModal"
            },
        },
        data(){
            return {
                // alertText : "",
                btnText: 'Okay'
            }
        },
        methods: {
            show(alertText, btnText = 'Okay'){
                // this.alertText = alertText;
                this.btnText = btnText;
                
                $('#' + this.modalId + '-content').html(alertText);
                $('#' + this.modalId).modal({
                    show: true,
                    backdrop: 'static',     
                    keyboard: false
                })
            },
            hide(){
                $('#' + this.modalId).modal('hide');
                $('#' + this.modalId + '-content').html('');
                // this.alertText = ""
            }
        },
        mounted() {
            // Emit alert event
            const $this = this;
            window.eventBus.$on('alertModal', (message) => {
                $this.show(message)
            });
        }
    }
</script>